import { gql } from "@apollo/client";

export const PROFILE = gql`
    query profile {
        profile {
            userId
            balance
            phoneNumber
            studentNumber
            firstName
            lastName
            isActive
            gender
            clientTz
            dateJoined
            lessonRemindsAt
            lessonRemindsAtEnabled
            supportId
            insuffCardCounter
            commited
            birthYear
            martialStatus
            childrenCount
            province
            city
            profession
            eduType
            degree
            universityEdu
            hawzahEdu
            education
            chatPlatforms
            isDropout
            isGraduated
            monthlyDonationReminder
            hasPassword
            meta {
                completedPercentage
                isFullFilled
            }
        }
    }
`;
